import Card from "@/components/Card";
import ACarousel from "@/components/Carousel";
import { convertIntoCard } from "./Utils";
import { ProgramListProps } from "./CompanyProgramModel";

const ProgramList: React.FC<ProgramListProps> = ({ dataList }) => {
  return (
    <div className="pt-10">
      {dataList &&
        Object.entries(dataList).map(([index, items]) => (
          <div key={index}>
            {items?.[0]?.minioUrl?.length && items[0].title.length > 1 ? (
              <div className="mx-6 pt-8">
                <ACarousel cardData={convertIntoCard(items)} />
              </div>
            ) : (
              <div className="mx-6 pt-8">
                <Card
                  title={items[0]?.title ?? ""}
                  excerpt={items[0]?.description ?? ""}
                  imageSrc={items[0]?.minioUrl ?? "/image-placeholder.png"}
                  imageLeft={items[0]?.contentPosition === 'Left' ? true : false }
                />
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

export default ProgramList;
